<template>
    <div>

    	<h1 class="mt-4">FAQ-sidor</h1>

    	<div class="tabs-container">

            <div class="tab" :class="{ 'active' : activeTab === 'customer_card' }" @click="activeTab = 'customer_card'">Webapp klippkortet</div>
            <div class="tab" :class="{ 'active' : activeTab === 'customer_card_en' }" @click="activeTab = 'customer_card_en'">Webapp klippkortet (Engelska)</div>
            <div class="tab" :class="{ 'active' : activeTab === 'customer_card_pt' }" @click="activeTab = 'customer_card_pt'">Webapp klippkortet PT</div>
            <div class="tab" :class="{ 'active' : activeTab === 'company_card' }" @click="activeTab = 'company_card'">Webapp för anställda</div>
            <div class="tab" :class="{ 'active' : activeTab === 'company_portal' }" @click="activeTab = 'company_portal'">Företagsportalen</div>

        </div>

        <div class="content-container">

            <transition :name="transitionName" :mode="transitionMode">
                <div class="new-list-group mb-10">
                    <div class="new-list-group-item new-list-group-header no-decoration">
                        <div class="row">
                            <div class="col-2"><span>Ordning</span></div>
                            <div class="col-9"><span>Fråga</span></div>
                            <div class="col-10"><span>Svar</span></div>
                            <div class="col-3"></div>
                        </div>
                    </div>
                    <transition-group name="flip-list" tag="div">
                        <question
                            :question="question"
                            :previousQuestion="filteredQuestions[index-1]"
                            :nextQuestion="filteredQuestions[index+1]"
                            :key="'q'+question.id"
                            v-for="(question, index) in filteredQuestions"
                            @refresh="fetcherFetch"
                        />
                    </transition-group>
                    <question-new
                        :type="activeTab"
                        @refresh="fetcherFetch"
                    />
                </div>
            </transition>

        </div>

    </div>
</template>

<script>
import question from './question.vue'

import tabber from '../../mixins/tabber'
import fetcher from '../../../shared/mixins/fetcher'
import questionNew from './question-new'

export default {

    mixins: [
        tabber,
        fetcher
    ],

    components: {
        questionNew,
        question
    },

    data () {
        return {

            questions: [],
            fetcher: {
                autoFill: [
                    'questions'
                ]
            },

        	defaultTab: 'customer_card',
            loading: false,
            transitionName: 'fade',
            transitionMode: 'out-in'
        }
    },

    computed: {
        fetcherUrl () {
            return '/faq-pages/fetch'
        },
        filteredQuestions () {
            return this.questions.filter(q => q.type === this.activeTab).sort((a, b) => a.order - b.order)
        }
    }
}
</script>
<style type="text/css">

/* --- Fade transition --- */
.fade-enter-active, .fade-leave-active {
    transition: all 350ms;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}

.flip-list-move {
    transition: transform 1s;
}

</style>
